import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Slider from 'react-slick';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import styles from './bodywon.module.css';
import ProductCard from './ProductCard';
import { fetchFeaturedProducts } from '../utils/productStorefront';

const NextArrow = (props) => (
  <div className={`${props.className} ${styles.featureArrow}`} onClick={props.onClick}>
    <FiChevronRight />
  </div>
);

const PrevArrow = (props) => (
  <div className={`${props.className} ${styles.featureArrow}`} onClick={props.onClick}>
    <FiChevronLeft />
  </div>
);

const FeatureProducts = ({ onAddToCart, catalogReady }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!catalogReady) return;
    let cancelled = false;

    const loadFeatured = async () => {
      try {
        const mapped = await fetchFeaturedProducts();
        if (!cancelled && mapped.length > 0) setProducts(mapped);
      } catch {
        /* no static fallback — only API featured products */
      }
    };

    loadFeatured();
    return () => {
      cancelled = true;
    };
  }, [catalogReady]);

  if (products.length === 0) return null;

  const count = products.length;
  const sliderSettings = {
    dots: false,
    infinite: count > 3,
    speed: 500,
    slidesToShow: Math.min(3, count),
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: Math.min(3, count) } },
      { breakpoint: 992, settings: { slidesToShow: Math.min(2, count) } },
      { breakpoint: 767, settings: { slidesToShow: 1, arrows: false, dots: true } },
    ],
  };

  return (
    <section className={styles.featureSection}>
      <Container>
        <h2 className={styles.featureTitle}>Feature Products</h2>
        <Slider {...sliderSettings}>
          {products.map((product) => (
            <div key={product.id} className={styles.featureCardWrapper}>
              <ProductCard product={product} onAddToCart={onAddToCart} />
            </div>
          ))}
        </Slider>
      </Container>
    </section>
  );
};

export default FeatureProducts;
